export default __webpack_public_path__ + "58f80fa85554b0d216bdcb9ecfddd402.png";